import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/filters/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listFilters, updateFilter } from "../../../redux/actions/table/superadmin/filters";
import EditFilterForm from "../../../forms/superadmin/filters/EditFilterForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateFilter(formData.id, _.omit(formData, ['id'])).then(() => {
                listFilters();

                this.props.readAction(formData.id);

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditFilterForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'product_attribute_template_field_ids']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
